import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.searchBar};
  padding: 15px 30px 15px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  form {
    flex: 0.9;
    max-width: 350px;
  }
`;

export const ViewChooser = styled.button`
  display: block;
  width: 30px;
  height: 30px;
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ViewSelector = styled.div`
  display: flex;
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  z-index: 99;
  gap: 12px;
  flex-wrap: wrap;
`;
